__turbopack_context__.v({
  "agreement_block": "iD0UPa_agreement_block",
});
